import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';


import { Form } from 'react-final-form';
import { toast } from 'react-toastify';

import {
  setBreadcrumbs,
  reduceServerErrors,
  UiToastAdapter,
  InnerLoader,
} from 'src/ui';
import {
  fetchFISettings,
  getFISettings,
  updateFISettings,
} from '../../financial-institution/redux';

import { Card, MuiTitle } from 'src/ui/mui-ui-kit';import { FISettingsEditPage } from '../components/FISettingsEditPage';
import { STATES } from '../const';

class FISettingsPageClass extends Component {
  state = {
    loading: true,
    initialValues: {},
    confirmChangesModal: false,
  };

  async componentDidMount() {
    const { setBreadcrumbs, fetchFISettings } = this.props;

    setBreadcrumbs([{ label: 'FI Settings', href: '/fi-settings' }]);

    const { user } = this.props;
    const fi = user.financialInstitutionId || user.fiSelectedAccountId;

    if (fi) {
      await Promise.all([fetchFISettings(fi)]);

      if (fi) {
        this.buildData();
      }
    }

    this.setState({ loading: false });
  }

  handleSubmit = async values => {
    return this.updateFISettings(values);
  };

  showModal = () => {
    this.toggleModal(true);
  };

  hideModal = () => {
    this.toggleModal(false);
  };

  toggleModal(value) {
    this.setState({ confirmChangesModal: value });
  }

  async updateFISettings(formValues) {
    const { user, updateFISettings, navigate } = this.props;
    const { ...values } = formValues;
    const fi = user.financialInstitutionId || user.fiSelectedAccountId;

    await updateFISettings({
      ...values,
      fi,
      financial_institution_dba_name: values.fiDbaName,
      financial_institution_restricted_words: values.fiRestrictedWords,
      financial_institution_media_check_emails: values.fiMediaCheckEmails,
      financial_institution_tin: values.fiTin,
      financial_institution_phone_number: values.fiPhoneNumber,
      financial_institution_email_address: values.fiEmailAddress,
      financial_institution_website: values.fiWebsite,
      financial_institution_registered_state:
        values.fiRegisteredState &&
        STATES.find(
          s => s.value === values.financial_institution_registered_state
        )
          ? STATES.find(
              s => s.value === values.financial_institution_registered_state
            ).value
          : null,
      financial_institution_support_name: values.fiSupportName,
      financial_institution_support_title: values.fiSupportTitle,
      financial_institution_support_email: values.fiSupportEmail,
      financial_institution_support_phone: values.fiSupportPhone,
      financial_institution_primary_address: values.fiPrimaryAddress,
      financial_institution_primary_address_2: values.fiPrimaryAddress2,
      financial_institution_primary_city: values.fiPrimaryCity,
      financial_institution_primary_state: values.fiPrimaryState,
      financial_institution_primary_zipcode: values.fiPrimaryZipcode,
      financial_institution_mailing_address: values.fiMailingAddress,
      financial_institution_mailing_address_2: values.fiMailingAddress2,
      financial_institution_mailing_city: values.fiMailingCity,
      financial_institution_mailing_state: values.fiMailingState,
      financial_institution_mailing_zipcode: values.fiMailingZipcode,
      financial_institution_sar_contact_office: values.fiSarContactOffice,
      financial_institution_sar_contact_phone: values.fiSarContactPhone,
      financial_institution_filing_institution_id: values.fiFilingInstitutionId,
      financial_institution_filing_institution_type:
        values.fiFilingInstitutionType,
      financial_institution_filing_institution_identification_type:
        values.fiFilingInstitutionIdType,
      financial_institution_primary_federal_regulator:
        values.fiPrimaryFederalRegulator,
      financial_institution_invite_email: values.fiInviteEmail,
      financial_institution_payment_account_invite:
        values.fiPaymentAccountInvite,
      financial_institution_payment_account_person_invite:
        values.fiPaymentAccountPersonInvite,
      financial_institution_fi_admin_invite: values.fiAdminInvite,
    });

    const { settings } = this.props;

    if (!settings) {
      return reduceServerErrors(settings);
    }

    await fetchFISettings();
    this.buildData();

    toast(UiToastAdapter('FI Settings Updated Successfully', 'success'));
    navigate('/fi-settings');
    return undefined;
  }

  buildData() {
    const { settings } = this.props;
    const fiSettings = settings.items;

    if (fiSettings) {
      const initialValues = {
        ...fiSettings,
        fiDbaName: fiSettings.financial_institution_dba_name,
        fiRestrictedWords: fiSettings.financial_institution_restricted_words,
        fiMediaCheckEmails: fiSettings.financial_institution_media_check_emails,
        fiTin: fiSettings.financial_institution_tin,
        fiPhoneNumber: fiSettings.financial_institution_phone_number,
        fiEmailAddress: fiSettings.financial_institution_email_address,
        fiWebsite: fiSettings.financial_institution_website,
        fiRegisteredState: STATES.find(
          s => s.value === fiSettings.financial_institution_registered_state
        ),
        fiSupportName: fiSettings.financial_institution_support_name,
        fiSupportTitle: fiSettings.financial_institution_support_title,
        fiSupportEmail: fiSettings.financial_institution_support_email,
        fiSupportPhone: fiSettings.financial_institution_support_phone,
        fiPrimaryAddress: fiSettings.financial_institution_primary_address,
        fiPrimaryAddress2: fiSettings.financial_institution_primary_address_2,
        fiPrimaryCity: fiSettings.financial_institution_primary_city,
        fiPrimaryState: fiSettings.financial_institution_primary_state,
        fiPrimaryZipcode: fiSettings.financial_institution_primary_zipcode,
        fiMailingAddress: fiSettings.financial_institution_mailing_address,
        fiMailingAddress2: fiSettings.financial_institution_mailing_address_2,
        fiMailingCity: fiSettings.financial_institution_mailing_city,
        fiMailingState: fiSettings.financial_institution_mailing_state,
        fiMailingZipcode: fiSettings.financial_institution_mailing_zipcode,
        fiSarContactOffice: fiSettings.financial_institution_sar_contact_office,
        fiSarContactPhone: fiSettings.financial_institution_sar_contact_phone,
        fiFilingInstitutionId:
          fiSettings.financial_institution_filing_institution_id,
        fiFilingInstitutionType:
          fiSettings.financial_institution_filing_institution_type,
        fiFilingInstitutionIdType:
          fiSettings.financial_institution_filing_institution_identification_type,
        fiPrimaryFederalRegulator:
          fiSettings.financial_institution_primary_federal_regulator,
        fiInviteEmail: fiSettings.financial_institution_invite_email,
        fiPaymentAccountInvite:
          fiSettings.financial_institution_payment_account_invite,
        fiAdminInvite: fiSettings.financial_institution_fi_admin_invite,
        fiPaymentAccountPersonInvite:
          fiSettings.financial_institution_payment_account_person_invite,
        fiAssignAdminsToAccounts:
          fiSettings.financial_institution_assign_admins_to_accounts,
      };
      this.setState({ initialValues });
    }
  }

  render() {
    const { isExpanded, settings } = this.props;
    const fiSettings = settings.items;
    const { confirmChangesModal, loading, initialValues } = this.state;

    return (
      <>
        {/* <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          FI Settings
        </MuiTitle> */}
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          subscription={{
            submitting: true,
            dirty: true,
            hasValidationErrors: true,
            dirtyFieldsSinceLastSubmit: true,
          }}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
            values,
            form,
          }) => {
            return (
              <Card noValidate onSubmit={handleSubmit}>
                {/* <CardContent> */}
                <FISettingsEditPage
                  onSubmit={handleSubmit}
                  submitting={submitting}
                  hasValidationErrors={hasValidationErrors}
                  isDirty={dirtySinceLastSubmit || dirty}
                  isExpanded={isExpanded}
                  values={values}
                  form={form}
                  confirmChangesModal={confirmChangesModal}
                  settings={fiSettings}
                />
                {/* </CardContent> */}
                <InnerLoader visible={loading || submitting} />
              </Card>
            );
          }}
        />
      </>
    );
  }
}

FISettingsPageClass.propTypes = {
  navigate: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  isExpanded: propTypes.bool.isRequired,
  user: propTypes.object.isRequired,
  settings: propTypes.object.isRequired,
  fetchFISettings: propTypes.func.isRequired,
  updateFISettings: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    settings: getFISettings(state),
  };
}

const ConnectedFISettingsPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchFISettings,
  updateFISettings,
})(FISettingsPageClass);

// Wrapper component to provide navigate function to class component
export function FISettingsPage(props) {
  const navigate = useNavigate();
  return <ConnectedFISettingsPage {...props} navigate={navigate} />;
}
